import React from 'react';
const GetDataSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='20'
      viewBox='0 0 18 20'
      fill='none'
      className={className}
      {...props}
    >
      <path
        d='M10.7778 16.95C10.7778 17.9441 9.98187 18.75 9 18.75C8.01813 18.75 7.22222 17.9441 7.22222 16.95M10.7778 16.95C10.7778 15.9559 9.98187 15.15 9 15.15M10.7778 16.95H17M7.22222 16.95C7.22222 15.9559 8.01813 15.15 9 15.15M7.22222 16.95H1M9 15.15V11.55M9 11.55C13.4444 11.55 17 10.344 17 8.85V3.45M9 11.55C4.55556 11.55 1 10.344 1 8.85V3.45M17 3.45C17 4.94116 13.4183 6.15 9 6.15C4.58172 6.15 1 4.94116 1 3.45M17 3.45C17 1.95883 13.4183 0.75 9 0.75C4.58172 0.75 1 1.95883 1 3.45'
        stroke='black'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export default GetDataSVG;
